export default __webpack_public_path__ + "static/media/LesA-white.45725656.png";